module.exports = __webpack_public_path__ + "static/media/mobile1.7742b657.png";